import React, { useRef, useState, useEffect } from 'react';
import { useIntersection } from '../hooks/useScrolled';
import './NewCollections.css';

export default function NewCollections() {
  const ref = useRef(null);
  const visible = useIntersection(ref);

  const [slides, setSlides] = useState([]);
  const [active, setActive] = useState(0);

  // 🔥 Fetch from WP
  useEffect(() => {
    fetch("https://admin.jksjewels.com/wp-json/wp/v2/collections")
      .then(res => res.json())
      .then(data => {
        const formatted = data.map(item => ({
          id: item.id,
          image: item.acf?.image,
          alt: item.acf?.alt || "Jewellery",
          brand: item.acf?.brand || "JKS",
          sub: item.acf?.sub_text || "Collections",
          wide: item.acf?.wide || false
        }));
        setSlides(formatted);
      })
      .catch(err => console.error("API Error:", err));
  }, []);

  useEffect(() => {
  if (!slides.length) return;

  const interval = setInterval(() => {
    setActive((prev) =>
      prev === slides.length - 1 ? 0 : prev + 1
    );
  }, 3500); // 3.5 sec

  return () => clearInterval(interval);
}, [slides]);

  
const MAX_ITEMS = Math.min(2, slides.length);

const visibleSlides = Array.from({ length: MAX_ITEMS }, (_, i) =>
  slides[(active + i) % slides.length]
);

  const prev = () => {
  if (!slides.length) return;
  setActive((i) => (i === 0 ? slides.length - 1 : i - 1));
};

const next = () => {
  if (!slides.length) return;
  setActive((i) => (i === slides.length - 1 ? 0 : i + 1));
};

  // Prevent empty render
  if (!slides.length) return null;

  return (
    <section className="new-collections" ref={ref}>

      {/* Header (STATIC as per your choice) */}
      <div className={`new-collections__header${visible ? ' visible' : ''}`}>
        <span className="new-collections__label">Sparkling Endeavor</span>
        <h2 className="new-collections__title">
          All New <em>Collections</em>
        </h2>
        <p className="new-collections__sub">
          Celebrate every occasion in pure gold elegance, the JKS Gold Jewels Collection,
           where intricate craftsmanship meets festive brilliance, made to shine, gift, and treasure forever.
        </p>
      </div>

      {/* Grid */}
      <div className={`new-collections__grid${visible ? ' visible' : ''}`}>

        {/* Prev */}
        <button className="new-collections__arrow new-collections__arrow--prev" onClick={prev}>
          <svg width="20" height="20" viewBox="0 0 20 20">
            <path d="M13 4L7 10L13 16" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {/* {slides.map((slide, i) => ( */}
        {visibleSlides.map((slide, i) => (
          <div
            key={slide.id}
            className={`new-collections__card 
              ${slide.wide ? ' new-collections__card--wide' : ''} 
              ${i === active ? ' active' : ''}`}
            onClick={() => setActive(i)}
          >
            <div className="new-collections__card-img">
              <img src={slide.image} alt={slide.alt} />
              <div className="new-collections__card-overlay" />
            </div>

            <div className="new-collections__card-label">
              <span className="nc-brand">{slide.brand}</span>
              <span className="nc-sub">{slide.sub}</span>
            </div>
          </div>
        ))}

        {/* Next */}
        <button className="new-collections__arrow new-collections__arrow--next" onClick={next}>
          <svg width="20" height="20" viewBox="0 0 20 20">
            <path d="M7 4L13 10L7 16" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

      </div>
    </section>
  );
}